import React, {useState, useEffect} from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Container,
  Button,
  Modal,
  ModalHeader
} from "reactstrap";

import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';

import FormKit from './Form';
import useToggle from 'lib/useToggle'
import Loading from 'lib/loading'
import rotas from 'services/rotas'
import rest from 'lib/rest'

const Kit = () => {

  const { SearchBar }                       = Search;
  const [kit_id, setKit_id]                 = useState("");
  const [modal, setModal]                   = useToggle(false);
  const [loading, setLoading]               = useState(true);
  const [ListaKit, setListaKit]             = useState([]);
  const [refresh,setRefresh]                = useState(0);
  // const [totalPaginacao, setTotalPaginacao] = useState(1);
  // const [pagina, setPagina]                 = useState(1);
  
  const colunas = [
    {
      dataField: 'kit_id',
      text: 'Código',
      headerStyle: { cursor: 'default' }
    },
    {
      dataField: 'kit_nome',
      text: 'Nome',
      headerStyle: { cursor: 'default' }
    },
    {
      dataField: 'kit_saldo',
      text: 'Saldo',
      headerStyle: { cursor: 'default' }
    },
    {
      dataField: 'kit_ativo',
      text: 'Ativo',
      headerStyle: { cursor: 'default' },
      formatter: (cellContent, row) => {
        if (cellContent === 'S') {
          return (<div className="timeline-heading"><span className="badge badge-success badge-pill m-0 aberto">Sim</span></div>)
        } else {
          return (<div className="timeline-heading"><span className="badge badge-info badge-pill m-0 aberto">Não</span></div>)
        }
      }
    }
  ]

  const abreModal = (id) => {
    setKit_id(id);
    setRefresh(refresh+1);
    setModal();
  }

  const fechaModal = (valor) => {
    setRefresh(refresh+1);
    listaKit();
    setModal();
  }

  const listaKit = ()=>{

    const url     = rotas.Kit;
    const retorno = rest.get(url);

    retorno.then(ret => {
      if (ret.success && ret.success === 'S'){
        // setTotalPaginacao(ret.total);
        setListaKit(ret.lista)
      }else{
        setListaKit([])
      }
      setLoading(false);
    })
  }

  useEffect(() => {
    const load = loading;
    if (load === true) {
      listaKit();
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  if (loading) {
    return (
      <Loading
        tipo='paginas'
      />
    )
  }else {
    return(
        <div className="content" key="585">
          <Container>
            <Row>
              <Col md="12" className="p-0">
                <Card>

                  <CardHeader>
                    <CardTitle>KIT</CardTitle>
                  </CardHeader>
                  <CardBody>

                    <ToolkitProvider
                      search
                      keyField  = "kit_id"
                      data      = {ListaKit}
                      columns   = {colunas}
                    >
                      {
                        props => (
                          <div>
                            <Container>
                              <Modal
                                key     = 'modalT'
                                size    = 'xl'
                                isOpen  = {modal}
                              >
                                <ModalHeader>Cadastro do Kit</ModalHeader>
                                <FormKit
                                  kit_id          = {kit_id}
                                  setKit_id       = {setKit_id}
                                  recarregaLista  = {listaKit}
                                  fechaModal      = {fechaModal}
                                >
                                </FormKit>
                              </Modal>
                              <Row>
                                <Col md="3">
                                  <Button
                                    outline
                                    className = "m-0 w-100"
                                    color     = "primary"
                                    style     = {{ padding: '5px 20px' }}
                                    onClick   = {() => abreModal('')}
                                  >
                                    <i className="fas fa-plus" />
                                    Cadastrar
                                  </Button>
                                </Col>

                                <Col md="9">
                                  <SearchBar
                                    placeholder = "Buscar Kit..."
                                    style       = {{ padding: '5px' }}
                                    {...props.searchProps}
                                  />
                                </Col>
                              </Row>
                            </Container>

                            <hr />

                            <BootstrapTable
                              striped
                              keyField          = 'kit_id'
                              data              = {ListaKit}
                              columns           = {colunas}
                              noDataIndication  = "Nenhum registro encontrado"
                              pagination        = {paginationFactory({
                                                    // page:pagina,
                                                    sizePerPage: 10,
                                                    // totalSize: totalPaginacao,
                                                    hideSizePerPage: true,
                                                    hidePageListOnlyOnePage: true,
                                                    showTotal: false,
                                                  })}
                              rowStyle          = {{ cursor: "pointer" }}
                              rowEvents         = {{
                                                    onDoubleClick: (e, row, rowIndex) => {
                                                      abreModal(row.kit_id)
                                                    }
                                                  }}
                              {...props.baseProps}                           
                            />
                          </div>
                        )
                      }
                    </ToolkitProvider>

                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
    )
  }
}

export default Kit;